export function guessUploadContentType(file: File): string {
  const extension = file.name.toLowerCase().split('.').pop();
  switch (extension) {
    case 'mp4':
    case 'm4v':
      return 'video/mp4';
    case 'webm':
      return 'video/webm';
    case 'mov':
      return 'video/quicktime';
    default:
      break;
  }
  if (file.type) return file.type;
  switch (extension) {
    case 'wav':
      return 'audio/wav';
    case 'mp3':
      return 'audio/mpeg';
    case 'm4a':
      return 'audio/mp4';
    case 'flac':
      return 'audio/flac';
    default:
      return 'audio/wav';
  }
}
